import { render, staticRenderFns } from "./ContactDetails.vue?vue&type=template&id=d68c3c36&scoped=true&"
import script from "./ContactDetails.vue?vue&type=script&lang=ts&"
export * from "./ContactDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ContactDetails.vue?vue&type=style&index=0&id=d68c3c36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d68c3c36",
  null
  
)

export default component.exports